export default __webpack_public_path__ + "static/media/cgiar-pdf-footer-logo.5740cb65.png";